import { Component, Input } from '@angular/core';
import { PaymentOffset } from '../../../../models/api/view/claim/financials/payment-history/payment-offset';
import { LoadingPanelComponent } from '../../../core/panels/loading-panel.component';
import { TableComponent } from '../../../core/table/table.component';
import { ColumnComponent } from '../../../core/table/column.component';

@Component({
  selector: 'app-payment-allocation-offsets',
  imports: [LoadingPanelComponent, TableComponent, ColumnComponent],
  template: `<div class="tw-pb-4 tw-pt-6">
    <app-loading-panel state="Loaded">
      <ng-template #loaded>
        Includes offsets, elective deductions, and/or supplementals
        <app-table
          [dataSource]="paymentOffset"
          [pageSize]="5"
          recordLabel="Record"
          [showExport]="false"
          dataKey="allocateUid"
        >
          <app-column name="adjustmentAction" label="Adjustment action" />
          <app-column name="adjustmentType" label="Type" />
          <app-column name="subType" label="Subtype" />
          <app-column name="source" label="Source" />
          <app-column name="amount" label="Amount" format="c" />
          <app-column name="appliedTo" label="Applied to" />
        </app-table>
      </ng-template>
    </app-loading-panel>
  </div>`,
  styles: [],
})
export class PaymentAllocationOffsetsComponent {
  @Input() allocateUid: any;
  @Input() paymentOffset: PaymentOffset[] = [];
}
